import React, { useState, useEffect, useContext } from "react";
import { TextsContext } from "context/textsContext";
import { Fragment } from "react";
import Stylegeneral from "scss/general.module.scss";
import styleForm from "scss/form.module.scss";
import { TitleH2Component } from "components/TitleH2Component";
import { TitleH1Component } from "components/TitleH1Component";
import { TitleH3Component } from "components/TitleH3Component";
import SelectBenefitsComponent from "components/SelectBenefitsComponent";
import { useQuoteFormContext } from "hooks/useQuoteFormContext";
import { arrayIncludesNumber, renderWithRegistered } from "helpers/toolsHelper";
import styleTexto from "scss/text.module.scss";
import { getCoverageOptionsVisibleFields } from "helpers/CoverageOptionsVisibility";
import { ImportantMessage } from "pages/Step11/component/ImportantMessage";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Icon } from "@iconify/react";

/**
 * Coverage Options step shared by the quoter and the favorite-plan template
 * form. Which context it reads/writes is picked by useQuoteFormContext based
 * on the current route - the two forms keep separate state, this is only
 * the shared UI + field-visibility logic.
 */
const CoverageOptionsStep = () => {
    const { texts, verifyCurrentLanguage } = useContext(TextsContext);
    const { benefits, selectedBenefitsIds, limitedCover, handleChecks, contextState } =
        useQuoteFormContext();
    const [isMobileDevice, _setIsMobileDevice] = useState(false);
    const [mostarPais, setMostrarPais] = useState(false);
    const [Providers, setProviders] = useState(false);

    const { isCountryResidenceDeductible } = contextState;
    const visibleFields = getCoverageOptionsVisibleFields(selectedBenefitsIds, isCountryResidenceDeductible);

    const textDeductible = texts?.step11_form_field_deductible ?? 'Deductible';
    const outsideTextCountryResidenceDeductible = texts?.step11_form_field_outside_new_deductible ?? 'Deductible Outside the Country of Residence.';
    const outsideTextUsaDeductible = texts?.step11_form_field_outside ?? 'Deductible outside U.S.';
    const outsideTextDeductible = isCountryResidenceDeductible ? outsideTextCountryResidenceDeductible : outsideTextUsaDeductible

    const insideTextCountryResidenceDeductible = texts?.step11_form_field_inside_new_deductible ?? 'Deductible Inside the Country of Residence.';
    const insideTextUsaDeductible = texts?.step11_form_field_inside ?? 'Deductible inside U.S.';
    const insideTextDeductible = isCountryResidenceDeductible ? insideTextCountryResidenceDeductible : insideTextUsaDeductible

    useEffect(() => {
        verifyCurrentLanguage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const paragraphgeneral_header_title = texts?.general_header_title;

    return (
        <Fragment>
            <section id="sectionscroll">
                <div className="container ">
                    <div className="d-block d-lg-none ">
                        <TitleH2Component styleGroup={`raleway fw_400 lh_40 color_secundary mb-0 py-2 ${Stylegeneral.titulo_principal}`}>
                            <p className={Stylegeneral.marca_registradaContainer}>
                                {renderWithRegistered(paragraphgeneral_header_title)}
                            </p>

                        </TitleH2Component>
                    </div>
                    <TitleH1Component styleGroup={`raleway_semibold fw_700  lh_30 color_primary pb-2 ${Stylegeneral.titulo}`}>
                        {texts?.step11_title ?? 'Choose coverage that works best for you and your family'}
                    </TitleH1Component>

                    <TitleH3Component styleGroup={`Poppins fw_400 color_primary pb-3 ${styleTexto.tamasubparrafo} ${Stylegeneral.titulo}`}>
                        {texts?.step11_phrase ?? "Select  the options for the plan you'd like to build"}
                    </TitleH3Component>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className={`${Stylegeneral.rowForm} row gy-5 pb-5`}>

                        <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                    <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                        {texts?.step11_form_field_maximum ?? 'Maximum Coverage Amount'}
                                    </label>

                                    <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_maximum ?? 'Maximum coverage amount that the company covers during a contingency'} />
                                </div>

                                <SelectBenefitsComponent benefits={benefits.structuralData} benefit={"maxcovpipoly"} className={`${styleForm.customselectLine}`} />

                            </div>
                        </div>

                        <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                    <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                        {texts?.step11_form_field_geo ?? 'Geographical coverage'}
                                    </label>

                                    <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_geo ?? "Geographic area where the policy´s benefits apply"} />
                                </div>

                                <SelectBenefitsComponent setMostrarPais={setMostrarPais} benefits={benefits.structuralData} benefit={"geogrcov"} className={`${styleForm.customselectLine}`} />
                            </div>
                        </div>

                        {visibleFields.includes('provdnet') &&
                            <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                                <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                    <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                        <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                            {texts?.step11_form_field_providers_network ?? 'Provider network'}
                                        </label>

                                        <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_us_coverage ?? 'Providers and hospital networks in the United States where the policy can be used'} />

                                    </div>
                                    <SelectBenefitsComponent setProviders={setProviders} benefits={benefits.structuralData} benefit={"provdnet"} className={`${styleForm.customselectLine}`} />

                                </div>

                            </div>

                        }
                        <ImportantMessage geoId={selectedBenefitsIds.geogrcov} providerId={selectedBenefitsIds.provdnet} mostarPais={mostarPais} Providers={Providers} limitedCover={limitedCover} handleChecks={handleChecks} antiResponsive={true} />
                        {isCountryResidenceDeductible && visibleFields.includes('dedusa') &&
                            <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                                <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                    <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                        <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                            {insideTextDeductible}
                                        </label>

                                        <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_inside ?? 'The portion of covered expenses that must be paid by the insured before the benefits of the policy become payable by the company'} />
                                    </div>

                                    <SelectBenefitsComponent benefits={benefits.structuralData} benefit={"dedusa"} className={`${styleForm.customselectLine}`} />

                                </div>
                            </div>
                        }
                        {visibleFields.includes('dednonusa') &&
                            <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                                <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                    <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                        <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                            {isCountryResidenceDeductible
                                                ? outsideTextDeductible
                                                : (arrayIncludesNumber(Object.values(selectedBenefitsIds), "latam") || arrayIncludesNumber(Object.values(selectedBenefitsIds), "wwltd"))
                                                    ? textDeductible
                                                    : outsideTextDeductible
                                            }
                                        </label>

                                        <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_outside ?? 'The portion of covered expenses that must be paid by the insured before the benefits of the policy become payable by the company'} />
                                    </div>

                                    <SelectBenefitsComponent benefits={benefits.structuralData} benefit={"dednonusa"} className={`${styleForm.customselectLine}`} />

                                </div>
                            </div>
                        }
                        {!isCountryResidenceDeductible && visibleFields.includes('dedusa') &&
                            <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                                <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                    <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                        <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                            {insideTextDeductible}
                                        </label>

                                        <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_inside ?? 'The portion of covered expenses that must be paid by the insured before the benefits of the policy become payable by the company'} />
                                    </div>

                                    <SelectBenefitsComponent benefits={benefits.structuralData} benefit={"dedusa"} className={`${styleForm.customselectLine}`} />

                                </div>
                            </div>
                        }


                        <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                    <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                        {texts?.step11_form_field_coinsurance ?? 'Coinsurance'}
                                    </label>

                                    <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_coinsurance ?? 'Percentage that determines the amount and insured must contribute towards the total of covered expenses, once the deductible has been met'} />
                                </div>

                                <SelectBenefitsComponent benefits={benefits.structuralData} benefit={"coinsurance"} className={`${styleForm.customselectLine}`} />

                            </div>
                        </div>
                        {visibleFields.includes('maxcoinoop') && <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                <div className={`d-flex align-items-center ${Stylegeneral.contentLabel}`}>
                                    <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>
                                        {texts?.step11_form_field_pocket ?? 'Maximum Out of Pocket'}
                                    </label>

                                    <OverlayTriggerInfo isMobileDevice={isMobileDevice} text={texts?.step11_tooltip_pocket ?? 'Maximum amount an insured could pay for covered medical services and/or prescriptions each year. This does not include premiums, but does typically include deductible, coinsurance and copays'} />
                                </div>

                                <SelectBenefitsComponent benefits={benefits.structuralData} benefit={"maxcoinoop"} className={`${styleForm.customselectLine}`} />

                            </div>
                        </div>}

                    </div>
                    <TitleH3Component styleGroup={`Poppins fw_400 color_primary pb-3 ${styleTexto.tamasubparrafo} ${Stylegeneral.titulo}`}>
                        {texts?.step11_deducible ?? "*Only one (1) Deductible per person, per Policy Year applies. For family Policies, a maximum of two (2) Deductibles accumulated per Policy, per Policy Year will be applied."}
                    </TitleH3Component>

                    <ImportantMessage geoId={selectedBenefitsIds.geogrcov} providerId={selectedBenefitsIds.provdnet} mostarPais={mostarPais} Providers={Providers} limitedCover={limitedCover} handleChecks={handleChecks} />
                </div>
            </section>
        </Fragment>
    )
}

const OverlayTriggerInfo = ({ isMobileDevice, text }) => {
    return (
        <OverlayTrigger
            key={isMobileDevice ? 'left' : 'top'}
            placement={isMobileDevice ? 'left' : 'top'}
            overlay={<Tooltip id="tooltip-top" className="custom-tooltip">{text}</Tooltip>}
        >
            <Icon icon={'mdi:information-outline'} className={` color_gray_5 ${styleForm.iconselect}`} />
        </OverlayTrigger>
    );
};

export default CoverageOptionsStep;
